import axios from 'axios';

const { config } = window;

export default class Api {
  static getConf(multi = false) {
    const accessToken = localStorage.getItem('access_token');
    return {
      validateStatus: false,
      headers: {
        'x-response-wrapping': 'not-wrapped',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': multi ? 'multipart/form-data' : 'application/json',
      },
    };
  }

  static async post(url, data = {}, throwErrors = false) {
    const axiosConf = this.getConf();
    try {
      const response = await axios.post(config.apiUrl + url, data, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      Api.showError(e);
      return e;
    }
  }

  static async delete(url, throwErrors = false) {
    const axiosConf = this.getConf();
    try {
      const response = await axios.delete(config.apiUrl + url, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      Api.showError(e);
      return e;
    }
  }

  static async patch(url, data = {}, throwErrors = false) {
    const axiosConf = this.getConf();
    try {
      const response = await axios.patch(config.apiUrl + url, data, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      Api.showError(e);
      return e;
    }
  }

  static async get(url, throwErrors = false) {
    const axiosConf = this.getConf();
    try {
      const response = await axios.get(config.apiUrl + url, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      Api.showError(e);
      return e;
    }
  }

  static async uploadOneFile(url, file, throwErrors = false) {
    const axiosConf = this.getConf();
    const data = new FormData();
    data.append('file', file);

    try {
      const response = await axios.post(config.apiUrl + url, data, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      Api.showError(e);
      return e;
    }
  }

  static showError(e) {
    alert(e);
    console.log(e);
  }
}
